import { render, staticRenderFns } from "./DynamicListComponents.vue?vue&type=template&id=5583f3f7&"
import script from "./DynamicListComponents.vue?vue&type=script&lang=js&"
export * from "./DynamicListComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports